














import Vue from 'vue'
import ActionButton from '@/components/ActionButton.vue'

export default Vue.extend({
  name: "TextArea",
  props: {
    titleText: String,
    bodyText: String,
    onBtnClick: Function,
    btnText: String
  },
  components: {
    ActionButton
  }
})
